import { Component, Input, TemplateRef, type OnInit } from '@angular/core';
import type { GenericProductData } from '@legacy/common-ui-models';
import type { NgbSlideEvent } from '@ng-bootstrap/ng-bootstrap';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbCarousel, NgbSlide } from '@ng-bootstrap/ng-bootstrap';
import { NgTemplateOutlet } from '@angular/common';
import { ToStringPipe } from '@innogy/utils-deprecated';

import { GenericOfferCarouselIndicatorComponent } from '../generic-offer-carousel-indicator/generic-offer-carousel-indicator.component';

@Component({
  selector: 'wl-generic-offer-carousel',
  templateUrl: './generic-offer-carousel.component.html',
  styleUrls: [
    './generic-offer-carousel.component.ed.scss',
    './generic-offer-carousel.component.essent.scss',
  ],
  standalone: true,
  imports: [
    AutomationIdDirective,
    FaIconComponent,
    GenericOfferCarouselIndicatorComponent,
    NgbCarousel,
    NgbSlide,
    NgTemplateOutlet,
    ToStringPipe,
  ],
})
export class GenericOfferCarouselComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) products!: GenericProductData[];
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) productTemplate!: TemplateRef<any>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) listName!: string;

  currentSlide = 0;

  ngOnInit(): void {
    if (this.products.length > 2) {
      // get center slide and set as current
      this.currentSlide = Math.round((this.products.length - 1) / 2);
    }
  }

  get isFirstProduct() {
    return this.currentSlide === 0;
  }

  get isLastProduct() {
    return this.currentSlide === this.products.length - 1;
  }

  setCurrentSlide(event: NgbSlideEvent) {
    this.currentSlide = Number(event.current);
  }

  hasReserveHighlightSpace() {
    return this.products.some((e) => e.content.highlight);
  }
}
